import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useRequest } from '@/hooks'
import { PROFESSIONAL_GROUPS, USER_GROUPS, CONTENT, FEED } from '@modules/admin/feed/constants'
import { createProfessionalGroupRows, createCustomerGroupRows } from '@modules/admin/groups/actions'
import { createManageContentColumns, createManageFeedColumns } from '@modules/admin/feed/actions'
import Loading from '@modules/core/components/Loading'
import Table from '@modules/admin/common/table'
import CustomPagination from '@modules/tableComponents/Pagination'
import SearchField from '@modules/admin/common/fields/searchField'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import { RemoveModal } from '@modules/admin/groups/template'
import Consultations from '@services/Consultations'
import Select from 'react-select'
import Marketing from '@services/Marketing'

export const Panel = ({
  kind,
  className,
  columns,
  client,
  buttonText,
  filters,
  placeholder,
  nameSearchField,
  groupsClient,
}) => {
  const [selectedRemove, setSelectedRemove] = useState(null)
  const [numAssociatedContent, setNumAssociatedContent] = useState(0)
  const [selectedOption, setSelectedOption] = useState({ label: 'Todas las secciones', value: '' })
  const {
    t,
    i18n: { language: currentLanguage },
  } = useTranslation()

  const indexClient = (params) => {
    const newParams = selectedOption.value ? { ...params, 'filters[eq:section]': selectedOption.value } : params

    return params.search ? client.search(newParams, nameSearchField) : client.index(newParams)
  }
  const { data, loading, search, setSearch, pagination, fetch } = useRequest(indexClient, filters)

  const checkAssociatedContent = (feed) => {
    if (feed.type === 'FeedView')
      Marketing.MContent.index({ 'filters[eq:feed]': feed.attributes.id }).then((res) =>
        setNumAssociatedContent(res.meta.total)
      )
  }

  const onChangeSearch = ({ target: { value } }) => setSearch(value)
  const displayRemoveModal = (item) => {
    checkAssociatedContent(item)
    setSelectedRemove(item)
  }
  const hideRemoveModal = () => setSelectedRemove(null)

  useEffect(() => {
    fetch()
  }, [selectedOption])

  /*   useEffect(() => {
    
    if(data && kind === FEED){ 
      
      const searchGroupUsers = async (idFeed) => {
        return await Consultations.groupsFeeds.search(idFeed).then(res => res.data)
      }

      data.map(async feed => {
        
        const getGroups = await searchGroupUsers(feed.id)
        const groupsArray = Object.values(getGroups)[0]

        if(groupsArray){
          const usersGroupsArray = groupsArray.map(obj => obj.name)
          const usersGroupsArrayIDs = groupsArray.map(obj => obj.id)
          const usersGroupsText = usersGroupsArray.join(', '); 
          
          feed.attributes.userGroups = usersGroupsText
          feed.attributes.userGroupsIDs = usersGroupsArrayIDs
        }
        
        return feed
      
      })

    }


  }, [data]) */

  const removeItem = async () => {
    try {
      await client.delete(selectedRemove.id)
      setSelectedRemove(null)
      await fetch()
    } catch (e) {
      console.error(e.message)
    }
  }

  const manageKindRows = () => {
    if (data) {
      if (kind === CONTENT)
        return createManageContentColumns({
          columns,
          rows: data,
          kind,
          onDelete: displayRemoveModal,
          t,
        })
      else if (kind === FEED) {
        return createManageFeedColumns({
          columns,
          rows: data,
          kind,
          onDelete: displayRemoveModal,
          currentLanguage,
          t,
        })
      }

      if (kind === PROFESSIONAL_GROUPS)
        return createProfessionalGroupRows({
          columns,
          rows: data,
          kind,
          onDelete: displayRemoveModal,
        })
      else if (kind === USER_GROUPS)
        return createCustomerGroupRows({
          columns,
          rows: data,
          kind,
          onDelete: displayRemoveModal,
          currentLanguage,
        })
    }
  }

  const manageRemoveModalText = () => {
    if (kind === PROFESSIONAL_GROUPS)
      return (
        <>
          <label>{t('firstDisclaimerRemoveProfessionalGroup')}</label>
          <div>{t('secondaryDisclaimerRemoveProfessionalGroup')}</div>
        </>
      )
    else if (kind === USER_GROUPS)
      return (
        <>
          <label>{t('firstDisclaimerRemoveUserGroup')}</label>
          <div>{t('secondaryDisclaimerRemoveUserGroup')}</div>
        </>
      )
    else if (kind === CONTENT)
      return (
        <>
          <h2 className="deleteTitle">{t('feedDeleteContent')}</h2>
          <p>{t('feedDeleteFeedContent')}</p>
          <p>
            {t('feedQuestion')} <b>{t('feedDelete')}</b> {t('feedQuestionContent')}
          </p>
        </>
      )
    else if (kind === FEED)
      return numAssociatedContent ? (
        <>
          <h2 className="deleteTitle">{`${t('feedDeleteFeedAssignedTitle1')} ${numAssociatedContent} ${t(
            'feedDeleteFeedAssignedTitle2'
          )}`}</h2>
          <p>{t('feedDeleteFeedTextAssigned')}</p>
        </>
      ) : (
        <>
          <h2 className="deleteTitle">{t('feedDeleteFeed')}</h2>
          <p>{t('feedDeleteFeedText')}</p>
          <p>
            {t('feedQuestion')} <b>{t('feedDelete')}</b> {t('feedQuestionFeed')}
          </p>
        </>
      )
  }

  const sortBySection = () => {
    const sectionOptions = [
      {
        label: 'Todas las secciones',
        value: '',
      },
      {
        label: 'usecase',
        value: 'usecase',
      },
      {
        label: 'featured',
        value: 'featured',
      },
      {
        label: 'quicklink',
        value: 'quicklink',
      },
    ]

    return (
      <div style={{ maxWidth: 190 }}>
        <Select
          options={sectionOptions}
          className="selectSortBy"
          name="sectionSortBy"
          value={selectedOption}
          onChange={(option) => {
            setSelectedOption(option)
          }}
          styles={{ control: (provided) => ({ ...provided, height: 52 }) }}
        />
      </div>
    )
  }

  const rows = manageKindRows()

  let component
  if (loading) component = <Loading isFetching />
  else
    component = (
      <>
        <Table columns={columns} title={columns} rows={rows} />
        <CustomPagination
          onClickItem={(page) => fetch(page)}
          activePage={pagination.currentPage}
          totalPages={pagination.lastPage}
          maxButtons={7}
        />
      </>
    )

  return (
    <div className={className}>
      <Wrapper>
        <SearchField placeholder={t(placeholder)} value={search ?? ''} onChange={onChangeSearch} />
        {kind === CONTENT && sortBySection()}
        <Link className="feedCreateButton" to={`/${kind}/create`}>
          {buttonText}
        </Link>
      </Wrapper>

      {component}
      {selectedRemove && (
        <RemoveModal
          className="tight"
          hide={hideRemoveModal}
          confirmFn={removeItem}
          text={manageRemoveModalText()}
          t={t}
          disabled={numAssociatedContent}
        />
      )}
    </div>
  )
}
const Wrapper = styled.div`
  display: flex;
  align-items: center;

  & > div {
    flex: 1;
    margin-right: 10px;
  }
`
